import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useProfessionalsChartsDataContext } from './hooks/useProfessionalsChartsDataContext';

export const EvolutionByCbo = () => {
    const { chartData } = useProfessionalsChartsDataContext();


    return (
        <SimpleBars
            title={'Quantidade de Profissionais - Atendimento Estratificado (10 maiores)'}
            horizontal={true}
            subtitles={chartData?.evolutionByCbo?.map((item) => item.description)}
            values={chartData?.evolutionByCbo?.map((item) => item.total  ||  0)}
        />
    );
};
